import { type fabric } from 'fabric';
import { type Constructor } from '../types';
import OpenUrlLinkControl from '../controls/OpenUrlLinkControl';
import type ShapePersistentControlBehaviors from './ShapePersistentControlBehaviors';

export interface LinkToUrlBehaviorsInterface {
  __hasLinkToUrlBehaviors: boolean;
  linkToUrl?: string;

  getObjectLinkedByUrl(): fabric.Object | undefined;
}

/**
 * Adds the ability to link something to a URL (which could be another object on
 * the same whiteboard). The url is stored in the attribute linkToUrl.
 * OpenUrlLinkControl is added as a persistent control to show the link
 * button.
 */
function LinkToUrlBehaviors(
  Base: Constructor<
    fabric.Object &
      ShapePersistentControlBehaviors & {
        serializedKeys: Array<string | RegExp>;
      }
  >
): any {
  return class extends Base implements LinkToUrlBehaviorsInterface {
    __hasLinkToUrlBehaviors = true;
    serializedKeys = [...this.serializedKeys, 'linkToUrl'];

    linkToUrl?: string;

    constructor(...args: any[]) {
      super(...args);

      if (!this.controller.canvas?.exporting) {
        this.persistentControls.openUrlLink = new OpenUrlLinkControl();
      }
    }

    getObjectLinkedByUrl() {
      if (!this.linkToUrl) {
        return;
      }

      const internalLink = this.controller.parseInternalLink(this.linkToUrl);

      if (internalLink) {
        const objectId = internalLink.hash?.replace('object-', '');

        return this.canvas.getObjects().find(obj => obj.id === objectId);
      }
    }
  };
}

export default LinkToUrlBehaviors;
